import {Controller} from "stimulus"
import $ from 'jquery';
import I18n from "i18n-js";



export default class extends Controller {

    connect() {
        let content = $('#content');
        if(content.length > 0){
            let a_link = content.find('a');
            if(a_link.length > 0){
                a_link.map((index,element) => {
                    $(element)[0].setAttribute('target','_blank');
                })
            }
        }
    }

}